export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_ERROR = "SIGNUP_ERROR";
export const SIGNUP_PENDING = "SIGNUP_PENDING";
export const SIGNUP_PENDING_SUCCESS = "SIGNUP_PENDING_SUCCESS";
export const SIGNUP_PENDING_ERROR = "SIGNUP_PENDING_ERROR";
export const CLEAR_SIGNUP_ERROR = "CLEAR_SIGNUP_ERROR";
export const ENABLE_USER_ERROR = "ENABLE_USER_ERROR";
export const ENABLE_USER_PENDING = "ENABLE_USER_PENDING";
export const ENABLE_USER_PENDING_SUCCESS = "ENABLE_USER_PENDING_SUCCESS";
export const CLEAR_ENABLE_USER_ERROR = "CLEAR_ENABLE_USER_ERROR";
export const ENABLE_USER_PENDING_ERROR = "ENABLE_USER_PENDING_ERROR";
export const CLEAR_SIGNUP_SUCCESS_MESSAGE = "CLEAR_SIGNUP_SUCCESS_MESSAGE";
